import { z } from 'zod';
import { DEMO_SHIFT_ANCHOR } from '@/mocks/db/pharmacyShift';
import { POSITION_KEYS } from './-utils';

/** 店舗詳細（勤務スケジュール）の検索パラメータ。 */
export const StoreDetailSearchSchema = z.object({
  view: z.enum(['daily', 'weekly', 'monthly']).default('weekly'),
  /** 各 view が中心に据える ISO 日付（YYYY-MM-DD）。 */
  anchor: z.string().default(DEMO_SHIFT_ANCHOR),
  // 表示設定（共有/リロードで保持したい。default と一致する値は URL から自動省略される）。
  group: z.boolean().default(true),
  alerts: z.boolean().default(true),
  budget: z.boolean().default(false),
  hideBg: z.boolean().default(true),
  hideOpen: z.boolean().default(false),
  // 絞り込み: 非表示にした職種のみを保持（全表示が default のため URL を短く保てる）。
  hidePos: z.array(z.enum(POSITION_KEYS)).default([])
});
export type StoreDetailSearchParams = z.infer<typeof StoreDetailSearchSchema>;
export type StoreDetailView = StoreDetailSearchParams['view'];